class DZModelWarrant{
    
    /**
     * 主键
     */
    id = "";

    /**
     * 土地信息ID
     */
    landId = "";

    /**
     * 权属类型
     */
    ownershipType = "";

    /**
     * 权证类型
     */
    warrantType = "";

    /**
     * 权证有效期开始时间
     */
    warrantValidityStart = 0;

    /**
     * 权证有效期结束时间
     */
    warrantValidityEnd = 0;

    /**
     * 更新用户ID
     */
    updateBy = "";

    /**
     * 更新时间
     */
    updateTime = "";

    /**
     * 发布用户ID
     */
    createBy = "";

    /**
     * 创建时间
     */
    createTime = "";
}
export default DZModelWarrant
